import { useState } from "react";
import { useHistory } from "react-router";
import wordsCount from "words-count";
import { useAppContext } from "../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../controller/article/ArticleController";
import Labels from "../../../lang/Labels_en";
import { handleErrorMessage, parseArticleForBackend, richTextStateToHtml, useEffectOnce } from "../../../utils/Utils";
import EnumYesNo from "../../../utils/enum/EnumYesNo";
// @ts-ignore
import { MUIEditorState } from "react-mui-draft-wysiwyg";
import MessageType from "utils/MessageType";
import EnumManuscriptType from "utils/enum/EnumManuscriptType";

interface GeneralInformationServiceType {
  types: any;
  typeOptions: any;
  firstTimeOptions: any;
  articleSave: any;
  wordCount: (value: any) => number;
}

export default function GeneralInformationService(): GeneralInformationServiceType {
  const { showMessage } = useAppContext();
  const { axiosGetTypes, axiosArticleSave }: ArticleControllerType = ArticleController();
  const [types, setTypes] = useState<any[]>([]);
  const history = useHistory();

  useEffectOnce(() => {
    getTypes();
  });

  const wordCount = (value: any) => {
    const htmlRegexG = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g;
    const text = richTextStateToHtml(value).replace(htmlRegexG, "").replaceAll("&nbsp;", "");
    return wordsCount(text);
  };

  const articleSave = (values: any, article: any, setArticle: any, handleNext: any) => {
    const words = wordCount(values.abstractText);

    if (values.type?.id === EnumManuscriptType.ORIGINAL_CONTRIBUTION) {
      if (words > 250) {
        showMessage("Max words for abstact is 250", MessageType.ERROR);
        return;
      }
    } else if (values.type?.id) {
      if (words > 200) {
        showMessage("Max words for abstact is 200", MessageType.ERROR);
        return;
      }
    }

    const mergeArticle = {
      ...article,
      ...values,
      authorsIds: article.articleAuthors ? article.articleAuthors.map((a: any) => a.id) : undefined,
    };

    if (values.type?.id === EnumManuscriptType.LETTER_TO_EDITOR) {
      mergeArticle["abstractText"] = MUIEditorState.createEmpty();
    }

    const newArticle = parseArticleForBackend(mergeArticle);

    axiosArticleSave(newArticle)
      .then((response: any) => {
        if (!article.id) history.push(`submit/${response.data.id}`);
        setArticle((article: any) => {
          return {
            ...article,
            id: response.data.id,
            uploadedById: response.data.uploadedBy.orcid,
            ...values,
            articleAuthors: response.data.articleAuthors,
          };
        });
        handleNext();
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const typeOptions = types.map((obj: any) => {
    return { name: obj.name, code: obj.id };
  });

  const firstTimeOptions = [
    { name: Labels.YES, code: EnumYesNo.YES },
    { name: Labels.NO, code: EnumYesNo.NO },
  ];

  const getTypes = () => {
    axiosGetTypes()
      .then((result: any) => {
        setTypes(
          result.data.filter(
            (type: any) => ![EnumManuscriptType.CASE_REPORTS, EnumManuscriptType.SOCIETY_NEWS].includes(type.id)
          )
        );
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  return { types, typeOptions, firstTimeOptions, articleSave, wordCount };
}

export type { GeneralInformationServiceType };
